import type { RouteRecordRaw } from 'vue-router';
import { SuperAdminRoutes } from '@/types/enums/RouteNameEnums';
import { NavigationKeyEnum } from '@/types/enums/NavigationKeyEnum';

export const superAdminRoutes: RouteRecordRaw[] = [
    {
        name: SuperAdminRoutes.Companies,
        path: '/companies',
        component: () => import('@/apps/super-admin/pages/companies/CompaniesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companies',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminCompanies,
        },
    },
    {
        name: SuperAdminRoutes.CompaniesCreate,
        path: '/companies/create',
        component: () => import('@/apps/super-admin/pages/companies/CompaniesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companies',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminCompanies,
        },
    },
    {
        name: SuperAdminRoutes.CompaniesEdit,
        path: '/companies/:id',
        component: () => import('@/apps/super-admin/pages/companies/CompaniesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companies',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminCompanies,
        },
    },
    {
        name: SuperAdminRoutes.CompaniesSettings,
        path: '/companies/:id/settings',
        component: () => import('@/apps/super-admin/pages/companies/CompaniesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companies',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminCompanies,
        },
    },
    {
        name: SuperAdminRoutes.Devices,
        path: '/admin-devices',
        component: () => import('@/apps/super-admin/pages/devices/DevicesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'devices',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminDevices,
        },
    },
    {
        name: SuperAdminRoutes.DevicesCreate,
        path: '/admin-devices/create',
        component: () => import('@/apps/super-admin/pages/devices/DevicesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'devices',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminDevices,
        },
    },
    {
        name: SuperAdminRoutes.DevicesEdit,
        path: '/admin-devices/:id',
        component: () => import('@/apps/super-admin/pages/devices/DevicesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'devices',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminDevices,
        },
    },
    {
        name: SuperAdminRoutes.FeatureFlags,
        path: '/feature-flags',
        component: () => import('@/apps/super-admin/pages/feature-flags/FeatureFlagsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'featureFlags',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminFeatureFlags,
        },
    },
    {
        name: SuperAdminRoutes.EanVersions,
        path: '/ean-versions',
        component: () => import('@/apps/super-admin/pages/ean-registry/EanVersionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'eanVersions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminEanVersions,
            superAdminOnly: true,
        },
    },
    {
        name: SuperAdminRoutes.EmailLogs,
        path: '/logs/emails',
        component: () => import('@/apps/super-admin/pages/logs/emails/EmailLogsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'emailLogs',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminEmailLogs,
            superAdminOnly: true,
        },
    },
    {
        name: SuperAdminRoutes.AntennaEpcTesting,
        path: '/testing/antenna-epc',
        component: () => import('@/apps/super-admin/pages/testing/AntennaEpcTestingPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'antennaEpcTesting',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminAntennaEpcTesting,
            superAdminOnly: true,
        },
    },
    {
        name: SuperAdminRoutes.DummyCashRegister,
        path: '/dummy-cash-register',
        component: () => import('@/apps/super-admin/pages/dummy-cash-register/DummyCashRegister.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'dummyCashRegister',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminDummyCashRegister,
            superAdminOnly: true,
        },
    },
    {
        name: SuperAdminRoutes.CapabilityDefinitions,
        path: '/capability-definitions',
        component: () => import('@/apps/super-admin/pages/capability-definitions/CapabilityDefinitionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'products.capabilityDefinitions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminCapabilityDefinitions,
            superAdminOnly: true,
        },
    },
    {
        name: SuperAdminRoutes.CapabilityDefinitionsCreate,
        path: '/capability-definitions/create',
        component: () => import('@/apps/super-admin/pages/capability-definitions/CapabilityDefinitionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'products.capabilityDefinitions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminCapabilityDefinitions,
            superAdminOnly: true,
        },
    },
    {
        name: SuperAdminRoutes.CapabilityDefinitionsEdit,
        path: '/capability-definitions/:id',
        component: () => import('@/apps/super-admin/pages/capability-definitions/CapabilityDefinitionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'products.capabilityDefinitions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.SuperAdminCapabilityDefinitions,
            superAdminOnly: true,
        },
    },
];
